import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';

import $ from 'jquery';

@Component({
  selector: 'app-divorced',
  templateUrl: './divorced.component.html',
  styleUrls: ['./divorced.component.scss']
})
export class WifeDivorcedComponent implements OnInit {

  deceased = this.appState.get();
  permanent_divorced_marriages_last_values = new Array(); // Deceased Wife Inheritance Last saved Values
  temp_marriages_last_values = new Array(); // Deceased Wife Inheritance Last saved Values
  divorced_last_values = new Array(); // Deceased Wife Inheritance Last saved Values

	constructor(public appState: AppService, public router: Router) {
		this.appState = this.appState;
	}

	/* Permanent Marriage Count Change */
	totalPermanentDivorceMarriageChange(event: any) {

		if( this.deceased.wife.permanent.count == 0 && this.deceased.wife.divorced.count == 0 ) { // Zero
		  this.permanent_divorced_marriages_last_values = this.deceased.wife.level1_wives = new Array();
		  this.deceased.wife.level1_wives = new Array();

		} else if( this.deceased.wife.permanent.count > 0 || (this.deceased.wife.divorced.count > 0) ) { // Greater Than Zero
		  
		  this.deceased.wife.level1_wives = new Array();


		  // Permanent Wives
		  for (var i = 0; i < this.deceased.wife.permanent.count; ++i) {
		    if( this.permanent_divorced_marriages_last_values[i] ) {
		    	this.deceased.wife.level1_wives.push( this.permanent_divorced_marriages_last_values[i] );
		    } else {
		      
		      var emptyObj = {
	            name: "Permanent Wife "+ (i+1),
	            type: "permanent",
	            eligibility: "",
	            muslim: "", 
	            deceased_killer: "", 
	            free_person: "true",
	            terminal_illness: "",
	            consummated: ""
	          };

		      this.deceased.wife.level1_wives.push(emptyObj);
		    }
		  }


		  // In Iddah-e-Talaq or Talaq-Rijee
		  if( this.deceased.wife.divorced.iddah_rijee_count > 0 ) {
		    for (var j = 0; j < this.deceased.wife.divorced.iddah_rijee_count; ++j) {

		        var emptyObj = {
		            name: "Wife in Iddah " + (j+1),
		            type: "iddah",
		            eligibility: "",
		            muslim: "", 
		            deceased_killer: "", 
		            free_person: "true",
		            terminal_illness: "",
		            consummated: ""
		          };

		        this.deceased.wife.level1_wives.push(emptyObj);
		    }
		  }

		  // Within one Lunar year of Talaq.. he was sick
		  if( this.deceased.wife.divorced.during_sick > 0 ) {

		    for (var k = 0; k < this.deceased.wife.divorced.during_sick; ++k) {

		      var kt = 0;  
		      // If All Conditions are met, then add the Wife to Level1 Inheritance List
		      if( this.deceased.wife.divorced.wives[k].wife_remarried == "true" && 
		        this.deceased.wife.divorced.wives[k].divorce_wanted_by_wife == "true" &&
		        this.deceased.wife.divorced.wives[k].husband_died_in_same_illness == "true") {

		            var emptyObj = {
						name: "Wife divorced in Sickness "+ (k+1),
						type: "sick",
			            eligibility: "",
			            muslim: "", 
			            deceased_killer: "", 
			            free_person: "true",
			            terminal_illness: "",
			            consummated: ""
			        };

		            this.deceased.wife.level1_wives.push(emptyObj);

		          kt++;
		      }


		    }
		  }

		  // Save Temp Marriage Count in Array
		  this.permanent_divorced_marriages_last_values = this.deceased.wife.level1_wives;

		}
	}


	/* Count Change of Within one Lunar year of Talaq (Rijee or Bayin) and husband divorced while he was sick */
	totalTalaqChange(event: any) {

		if( this.deceased.wife.divorced.during_sick == 0 ) { // Zero
		  this.divorced_last_values = this.deceased.wife.divorced.wives = new Array();

		} else if( this.deceased.wife.divorced.during_sick > 0 ) { // Greater Than Zero
		  
		  this.deceased.wife.divorced.wives = new Array();

		  for (var i = 0; i < this.deceased.wife.divorced.during_sick; i++) {
		    if( this.divorced_last_values[i] ) {
		      this.deceased.wife.divorced.wives.push( this.divorced_last_values[i] );
		    } else {

		      var emptyObj = {
		        wife_remarried: '', 
		        divorce_wanted_by_wife: '', 
		        husband_died_in_same_illness: ''
		      };

		      this.deceased.wife.divorced.wives.push(emptyObj);
		    }
		  }

		  // Save Temp Marriage Count in Array
		  this.divorced_last_values = this.deceased.wife.divorced.wives;

		}

		// Add/Remove Object in level1_wives Array
		this.totalPermanentDivorceMarriageChange(event);

	}


	/* Divorce Custom Radio Button */
	toggleTalaqOption(i, key, event: any) {
		if( this.deceased.wife.divorced.wives[i][key] == 'true' ) {
		  this.deceased.wife.divorced.wives[i][key] = 'false';
		} else {
		  this.deceased.wife.divorced.wives[i][key] = 'true';
		}

		// Add/Remove Object in level1_wives Array
		this.totalPermanentDivorceMarriageChange(event);

		event.preventDefault();
	}

	// Validation
	// Form Validation
	formValidate() {

		// Step#1: Required Inputs and Selects   
		var inputs = document.querySelectorAll(".step *[required]");

		if( inputs.length > 0 ) {
		  for (var i = 0; i < inputs.length; ++i) {
		    var input_elem = <HTMLInputElement>inputs[i];

		    if( input_elem.value == '' ) {
		      inputs[i].parentElement.classList.add("has-error");  
		      input_elem.focus();

		      $('html, body').animate({
		          scrollTop: $( ".has-error" ).offset().top
		      }, 500);

		      return false;
		    
		    } else {
		      inputs[i].parentElement.classList.remove("has-error");  
		    }
		  }
		}



		// Step#2: Check Radio Buttons whether they are checked or not
		var error = false;
		var radio_buttons_wrap = document.querySelectorAll(".step .radio-buttons-wrap");

		for (var i = 0; i < radio_buttons_wrap.length; ++i) {
		  var radio = radio_buttons_wrap[i].querySelectorAll("input[type='radio']");
		  var checked = false;
		  
		  for (var k = 0; k < radio.length; ++k) {
		    var radio_elem = <HTMLInputElement>radio[k];

		    if( radio_elem.checked ) {
		      checked = true;
		      break;
		    }
		  }

		  if( ! checked ) {
		    radio_buttons_wrap[i].parentElement.classList.add("has-error");

		    $('html, body').animate({
		        scrollTop: $( ".has-error" ).offset().top
		    }, 500);

		    return false;

		  } else {
		    radio_buttons_wrap[i].parentElement.classList.remove("has-error");
		  }
		}


		return true;
	}


	// Back Button
	back(event) {
		
		if( this.deceased.wife.temp.count > 0 ) {
			this.router.navigate(['wife/temp']);
		} else {
			this.router.navigate(['']);
		}
		
		event.preventDefault();
	}

	// Next Button is clicked
	next(event) {
		// Form Validation
	    if( this.formValidate() == false ) {
	      return;
	    }

	    // Save Values
		this.appState.set(this.deceased);

		// Redirect to Results Page
		this.router.navigate(['level1-inheritors']);

		event.preventDefault();

	}

	ngOnInit() {

	}

}
